import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const state = {
  user: {
    name: 'Guest',
    isLoggedIn: false,
    permission: [],
    expired: null
  },
  constant: {
    field: {
      types: [
        {name: "기본"},
        {name: "멀티 박스"},
        {name: "체크 박스"}
      ],
      languages: [
        {name: "한국어"},
        {name: "영어"},
        {name: "숫자"},
        {name: "특수기호"}
      ],
      dictionaries: [
        {name: '없음'},
        {name: '주소'},
        {name: '주문모델'},
        {name: '거래처'}
      ],
      writingTypes: [
        {name: '필기체'},
        {name: '인쇄체'}
      ]
    },
    fieldColors: [
      '#d11141', '#00b159', '#00aedb', '#f37735', '#ffc425'
    ]
  }
}

const mutations = {
  user (state, payload) {
    state.user = payload
  }
}

const getters = {
  fieldTypes: state => {
    return Object.keys(state.constant.field.types).map(key => state.constant.field.types[key].name)
  },
  fieldLanguages: state => {
    return Object.keys(state.constant.field.languages).map(key => state.constant.field.languages[key].name)
  },
  fieldDictionaries: state => {
    return Object.keys(state.constant.field.dictionaries).map(key => state.constant.field.dictionaries[key].name)
  },
  fieldWritingTypes: state => {
    return Object.keys(state.constant.field.writingTypes).map(key => state.constant.field.writingTypes[key].name)
  }
}

/* eslint-disable no-unused-vars */
const store = new Vuex.Store({
  state,
  mutations,
  getters
})

export default {
  store: store
}
